import React from 'react';

const ModalContentBase = ({ modalContent, closeModal, contentClassName = "" }) => {
  return (
    <div className="modal-view">
      <div className="modal-view-fade-in">
        <div className="modal-view-overAll">
          <div className="modal-view-overlay" onClick={() => closeModal()}>
            <div className="modal-xBtn font-size-28 cursor-pointer">×</div>
          </div>
          <div className="modal-view-large-dialog">
            <div className={`modal-view-content ${contentClassName}`.trim()}>{modalContent}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalContentBase;
